export const BookingServices = {
  en: {
    Position: 'Position',
    Name: 'Name',
    'Create Booking Service': 'Create Booking Service',
    Duration: 'Duration',
    Dur: 'Dur.',
    Color: 'Color',
    'For online': 'For online',
    'Online Payment Key': 'Online Payment Key',
  },
  uk: {
    Position: 'Позиція',
    Name: 'Назва',
    'Create Booking Service': 'Створити букінг сервіс',
    Duration: 'Тривалість',
    Dur: 'Трив.',
    Color: 'Колір',
    'For online': 'Для онлайн',
    'Online Payment Key': 'Платіжний ключ',
  },
};

export const BookingServiceForm = {
  en: {
    ...BookingServices.en,
    'New Booking Service': 'New Booking Service',
    'Edit Booking Service': 'Edit Booking Service',
    'Update Booking Service': 'Update Booking Service',
    Description: 'Description',
    'Service type': 'Service type',
    Total: 'Total',
    'for single booking': 'For single booking',
    'for multiple bookings': 'For multiple bookings',
    Image: 'Image',
    'Choose Image File': 'Choose Image File',
    'Available for online': 'Available for online booking',
    'Online Payment Key': 'Online Payment Key {{key_type}}',
    'At least one payment key must be selected':
      'At least one payment key must be selected',
  },
  uk: {
    ...BookingServices.uk,
    'New Booking Service': 'Новий Букінг Сервіс',
    'Edit Booking Service': 'Редагування Букінг Сервісу',
    'Update Booking Service': 'Оновити Букінг Сервіс',
    Description: 'Опис',
    'Service type': 'Тип сервісу',
    Total: 'Разом',
    'for single booking': 'Для індивідуального бронювання',
    'for multiple bookings': 'Для групового бронювання',
    Image: 'Зображення',
    'Choose Image File': 'Вибрати зображення',
    'Available for online': 'Доступно для онлайн бронювання',
    'Online Payment Key': 'Платіжний ключ {{key_type}}',
    'At least one payment key must be selected':
      'Необхідно вибрати хоча б один платіжний ключ',
  },
};
